// ng-zorro default stroke width
export const defaultProgressStrokeWidth = 6;
